import React, { useState, useEffect } from 'react'
import isEmpty from 'lodash/isEmpty'
import { apiGetComponentLocationForSocialNetwork } from 'services/SocialNetworkService'
import { Select } from 'components/ui'
// import { HiOutlineSearch } from 'react-icons/hi'
import { useDispatch, useSelector } from 'react-redux'
import { setTableData } from '../store/dataSlice'
import cloneDeep from 'lodash/cloneDeep'
import { useTranslation } from 'react-i18next';

const SocialNetworkTableLocation = () => {
	const [componentlocation, setData] = useState([])
	const { locale } = useSelector((state) => state.theme);

	const fetchData = async () => {
		const response = await apiGetComponentLocationForSocialNetwork()
		setData(response.data);
	}

	let nameLocale = '';

	if (locale === 'sq') {
		nameLocale = 'titleSq';
	} else if (locale === 'en') {
		nameLocale = 'titleEn';
	} else if (locale === 'sr') {
		nameLocale = 'titleSr';
	} else {
		nameLocale = 'titleSq';
	};

	const getOptionLabel = (option) => option[nameLocale];
	const getOptionValue = (option) => option.id;

	useEffect(() => {
		if (isEmpty(componentlocation)) {
			fetchData()
		}
	}, []);

	const dispatch = useDispatch();
	const tableData = useSelector((state) => state.socialnetworksList.data.tableData);

	// const onLocationChange = (option) => {
	// 	const newTableData = cloneDeep(tableData);
	// 	newTableData.componentLocationId = option.id;
	// 	dispatch(setTableData(newTableData));
	// };

	const onLocationChange = (option, { action }) => {
		if (action === 'clear') {
			const newTableData = cloneDeep(tableData);
			newTableData.componentLocationId = 0;
			newTableData.pageIndex = 1;
			dispatch(setTableData(newTableData));
		} else {
			const newTableData = cloneDeep(tableData);
			newTableData.componentLocationId = option.id;
			newTableData.pageIndex = 1;
			dispatch(setTableData(newTableData));
		}
	};

	const { t } = useTranslation();

	return (
		<Select
			className="lg:ml-0 lg:mr-0 xl:w-52 lg:w-full w-full md:w-full md:mb-0 mb-4"
			isClearable={true}
			options={componentlocation}
			placeholder={t('dropdown.LocationPlaceholder')}
			onChange={onLocationChange}
			getOptionLabel={getOptionLabel}
			getOptionValue={getOptionValue}
		/>
	)
}

export default SocialNetworkTableLocation